<template>
    <div class="experience-template-detail-dialog__wrap">
        <pt-drawer
            :model-value="visible"
            :custom-class="[
                $style.templateDetailDialog,
                isMobile && $style.templateDetailDialogMobile
            ]"
            @close="handleClose"
        >
            <div :class="$style.content">
                <wac-component
                    v-if="currentShowTemplate?.isfromEC"
                    display-mode="detail"
                    :lang="wacLang"
                    :component-data="currentShowTemplate?.data"
                    :asset-id="currentShowTemplate?.id"
                    @view="handleUseTemplate"
                ></wac-component>
                <TemplateDetail
                    v-else
                    :template="currentShowTemplate"
                    @use="handleUseTemplate"
                ></TemplateDetail>
            </div>
            <TemplateRecommandList
                position="template_detailpage_recommend"
                :entryPosition="props.entryPosition"
                :class="$style.moreList"
                :isFromEC="props.template?.isfromEC"
                :currentTemplate="currentShowTemplate"
                :isMobile="isMobile"
                recommandType="purpose"
                @view="handleSelectMoreTemplate"
                @create="handleUseTemplate"
            >
                <template #left>
                    <p :class="$style.moreTitle">
                        {{
                            currentShowTemplate?.isfromEC
                                ? $t('experience.onboarding.more_ideas_like')
                                : $t('experience.onboarding.more_template_like')
                        }}
                    </p>
                </template>
            </TemplateRecommandList>
        </pt-drawer>
    </div>
</template>

<script lang="ts">
import TemplateDetail from '@experience/components/template/TemplateDetail.vue';
import TemplateRecommandList from '@experience/components/template/TemplateRecommandList.vue';
export default {
    name: 'ExperienceTemplateDetail',
    components: {
        TemplateDetail,
        TemplateRecommandList
    }
};
</script>

<script lang="ts" setup>
import { ref, watch, onMounted, getCurrentInstance } from 'vue';
import type { ExperienceTemplateV4 } from '@models/experience/useExperienceTemplatesV4';
import type { ECTemplate } from '@models/ecshop/asset';
import { useECTemplates } from '@models/ecshop/asset';
import analyticsService from '@assets/services/analytics.service';
import { useRoleDialog } from '@master/hooks/service/useShowAuthDialog';
import { useRouter, useRoute } from 'vue-router';
import { useECEvent, ECDataLocation } from '@experience/hooks/template.hooks';

// interface
interface Props {
    visible: boolean;
    template: ExperienceTemplateV4 | ECTemplate;
    changeRoute: boolean;
    position: ECDataLocation;
    entryPosition?: string;
}
// props
const props = withDefaults(defineProps<Props>(), {
    changeRoute: false
});
const isMobile = ref(window.screen.width <= 750);
// emits
const emit = defineEmits(['close', 'create']);
const proxy = getCurrentInstance()?.proxy;
const router = useRouter();
const route = useRoute();

// state
const currentShowTemplate = ref<ExperienceTemplateV4 | ECTemplate | null>(props.template);
const { wacLang } = useECTemplates();
// computed

// watch
watch(
    () => props.template,
    () => {
        currentShowTemplate.value = props.template;
    }
);

onMounted(() => {
    // useECEvent('trackProductDetailImpression', props.template, props.position);
    // analyticsService
    //     .usePTX('cp_template_detail_click', {
    //         position: props.position,
    //         template_name: props.template.name
    //     })
    //     .track();
});

// onUnmounted

// function
function handleClose() {
    emit('close');
}
function handleSelectMoreTemplate(template: ExperienceTemplateV4 | ECTemplate) {
    if (props.changeRoute) {
        template?.id &&
            router.push({
                name: route.name === 'ProductGalleryView' ? 'ProductGalleryView' : 'GalleryView',
                params: {
                    templateId: template?.id
                },
                query: route.query
            });
    }

    currentShowTemplate.value = template;
}
function handleUseTemplate() {
    if (!useRoleDialog('experienceAdd') || !currentShowTemplate.value) {
        return;
    }

    emit('create', currentShowTemplate.value);
    useECEvent('trackAddToCart', currentShowTemplate.value, props.position);
    analyticsService
        .usePTX('cp_template_create_click', {
            type: currentShowTemplate.value.type,
            is_blank: 'N',
            template_position: 'template_detail',
            template_name: currentShowTemplate.value.name
        })
        .track();
}
</script>

<style lang="scss" module>
@import '@style/import.scss';

:global {
    // 当详情弹框出现【无权限弹框】时，需让无权限弹框层级更高
    body:has(.experience-template-detail-dialog__wrap > .pt-overlay) {
        & > .pt-overlay:not([aria-hidden='true']),
        & > .pt-popper {
            z-index: calc(#{$page-help-index} + 2) !important;
        }
    }

    .experience-template-detail-dialog__wrap {
        position: relative;
        z-index: calc(#{$page-help-index} + 1); // 需要比start guide层级高
    }
}
.templateDetailDialog {
    .content {
        min-height: 400px;
        max-width: 980px;
        background-color: $pt-white;
        padding: 40px;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        & > div {
            width: 100%;
        }
    }
    .moreList {
        .moreTitle {
            font-size: 20px;
            color: $pt-black-900;
            margin-bottom: 20px;
        }
    }
}

.templateDetailDialogMobile {
    width: 100% !important;
    max-height: 100% !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;

    :global {
        .pt-drawer__body {
            height: 100%;
        }
    }

    .content {
        padding: 0;
    }
}
</style>
